module.exports = __webpack_public_path__ + "img/sesxbg.d4153067.jpg";